import { create } from 'zustand';
import type { StateCreator } from 'zustand';

type AppMode = 'intro' | 'answering_questions' | 'transitioning_to_features' | 'viewing_features';

interface AppState {
  appMode: AppMode;
  activeSection: number;
  isInteractionReady: boolean;
  isNavigating: boolean;
  actions: {
    setAppMode: (mode: AppMode) => void;
    setNavigating: (isNav: boolean) => void;
    setSectionFromButton: (section: number) => void;
    setSectionFromScroll: (section: number) => void;
    handleNextOnLastQuestion: (sectionStarts: number[], vh: number) => void;
    completeTransition: () => void;
  };
}

const createAppState: StateCreator<AppState> = (set, get) => ({
  appMode: 'intro', // 👈 CORRECTED: The app starts in intro mode.
  activeSection: 0,
  isInteractionReady: true,
  isNavigating: false,

  actions: {
    setNavigating: (isNav) => set({ isNavigating: isNav }),
    setAppMode: (mode) => set({ appMode: mode }),
    
    // 👇 CORRECTED: Two distinct actions to prevent conflicts.
    setSectionFromButton: (section) => {
      set({ activeSection: section });
    },
    setSectionFromScroll: (section) => {
      if (get().isNavigating || get().appMode === 'transitioning_to_features') {
        return; // Ignore scroll events during button navigation or the final transition.
      }
      set({ activeSection: section });
    },
    
    handleNextOnLastQuestion: (sectionStartVhValues, viewportHeight) => {
      set({ appMode: 'transitioning_to_features', activeSection: 12, isInteractionReady: false });
      const sectionTopPx = (sectionStartVhValues[12] / 100) * viewportHeight;
      window.scrollTo({ top: sectionTopPx, behavior: 'auto' });
    },
    completeTransition: () => {
      set({ appMode: 'viewing_features' });
      setTimeout(() => set({ isInteractionReady: true }), 150);
    },
  },
});

export const useAppStore = create<AppState>(createAppState);